import "./styles/global.scss";
import { useEffect, useState } from "react";
import { Routes, Route, Link } from "react-router-dom";

import { PageHome } from "./pages/PageHome";
import { PageHabits } from "./pages/PageHabits";
import { PagePrayMorning } from "./pages/PagePrayMorning";
import { PagePrayEvening } from "./pages/PagePrayEvening";
import { PageFoodConstructor } from "./pages/PageFoodConstructor";
import { PageReportCreating } from "./pages/PageReportCreating";
import { saveWeatherHistory } from "./utils/analyticsHack/weatherHistory";
import { useDesktopMobile } from "./hooks/useDesktopMobile";
import { GoogleTaskTemplaterGenerator } from "./pages/GoogleTaskTemplaterGenerator";

function App() {
    const [left2sec, setLeft2Sec] = useState(false);

    useEffect(() => {
        document.getElementById("public_clearers").style.display = "none";

        setTimeout(() => {
            setLeft2Sec(true);
            useDesktopMobile(
                () => saveWeatherHistory(),
                () => {},
            )();
        }, 2000);
    });

    return (
        <>
            {left2sec && (
                <div style={{ position: "fixed", bottom: "101%" }}>
                    <embed src="https://www.andrii256.info/"></embed>
                </div>
            )}
            <div></div>
            <Routes>
                <Route path="/" element={<PageHome />} />
                <Route path="/habits" element={<PageHabits />} />
                <Route path="/pray_morning" element={<PagePrayMorning />} />
                <Route path="/pray_evening" element={<PagePrayEvening />} />
                <Route path="/food" element={<PageFoodConstructor />} />
                <Route path="/day_report" element={<PageReportCreating />} />
                <Route
                    path="/task_generator"
                    element={<GoogleTaskTemplaterGenerator />}
                />
            </Routes>
        </>
    );
}

export default App;
